(() => {
  if (!customElements.get('ff-topsellers')) {
    customElements.define('ff-topsellers', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.ff-topsellers__track');
        if (!this.track) return;
        this.cards = [...this.track.children];
        this.prev = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.status = this.querySelector('.ff-topsellers__status');
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options);
        });
        this.track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.update(), 100);
        }, { ...options, passive: true });
        this.resize?.disconnect();
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        clearTimeout(this.timer);
      }
      move(direction) {
        const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reduced ? 'instant' : 'smooth' });
      }
      update() {
        if (!this.isConnected || !this.track.clientWidth) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.querySelector('.ff-topsellers__controls').hidden = max < 3;
        this.prev.disabled = this.track.scrollLeft < 3;
        this.next.disabled = this.track.scrollLeft >= max - 3;
        const rect = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(card => card.rect.left >= rect.left - 3 && card.rect.right <= rect.right + 3);
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible.at(-1).index + 1;
          const text = `${first === last ? first : `${first}–${last}`} / ${this.cards.length}`;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
      }
    });
  }

  // Follow actual grid columns; survive filter replacements and appended pages.
  if (!customElements.get('ff-topseller-placement')) {
    customElements.define('ff-topseller-placement', class extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('#ProductGridContainer');
        if (!this.container) return;
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.position());
        };
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.container, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-productis-in-row'] });
        this.resize = new ResizeObserver(this.schedule);
        this.resize.observe(this.container);
        window.addEventListener('resize', this.schedule);
        this.schedule();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.resize?.disconnect();
        window.removeEventListener('resize', this.schedule);
        this.insert?.remove();
      }
      position() {
        if (!this.querySelector('template')?.content.querySelector('ff-topsellers')) return;
        const grid = this.container.querySelector('#product-grid');
        if (!grid || Number(grid.dataset.collectionPageOffset || 0) !== 0) return;
        const cards = [...grid.querySelectorAll(':scope > .collection-product-card')];
        const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
        const rows = Math.max(1, Number.parseInt(this.dataset.afterRows || '2', 10) || 2);
        const after = columns * rows;
        if (cards.length <= after) {
          this.insert?.remove();
          return;
        }
        if (!this.insert) this.insert = this.querySelector('template').content.firstElementChild.cloneNode(true);
        const anchor = cards[after - 1];
        if (anchor.nextElementSibling !== this.insert) anchor.after(this.insert);
      }
    });
  }
})();
